import { render } from "./upload_att.vue?vue&type=template&id=5f08c56a"
import script from "./upload_att.vue?vue&type=script&lang=js"
export * from "./upload_att.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__